// i18n
import { i18n } from '@ecg-internal/js-react-i18n';
import { nl as dateLocale } from 'date-fns/locale/nl';
import translation from '../../../../locales/nl-BE/translation.json';
import common from '../../../../locales/nl-BE/common.json';
import priceTypes from '../../../../locales/nl-BE/priceTypes.json';
import p2pPaymentsUi from '@ecg-internal/p2p-payments-ui/locales/nl-BE.json';
import reviewsDialogUi from '@ecg-internal/reviews-dialog-ui/locales/nl-BE.json';
import favouritesUi from '@ecg-internal/favourites-ui/locales/nl-BE.json';

export default i18n.init({
  lng: 'nl-BE',
  dateLocale,
  translations: {
    translation,
    common,
    priceTypes,
    p2pPaymentsUi,
    reviewsDialogUi,
    favouritesUi,
  },
});
